import { connect } from 'react-redux'
import SelectionItem from './SelectionItem'
import { openStompunkt, removeSelected } from '../../actionCreators'

const mapStateToProps = (state, ownProps) => ({
   stompunkt: state.lightStompunkter[ownProps.id]
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: () => dispatch(openStompunkt(ownProps.id)),
  onRemove: () => dispatch(removeSelected(ownProps.id))
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectionItem);


// WEBPACK FOOTER //
// ./src/components/Selection/SelectionItemContainer.js